import Header, { HeaderProps } from '@/components/atoms/Header';
import Image from 'next/image';
import * as S from './styles';
import Button from '@/components/atoms/Button';
import logo_chippu_place from '@/assets/logo_chippu_place.svg';
import { IconeSeta } from '@/components/atoms/Icones/IconeSeta';
import { useTheme } from 'styled-components';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import useBreakpoint from '@/hooks/useBreakpoint';

export default function CabecalhoComBotaoVoltar(props: HeaderProps) {
  const { breakpoint } = useBreakpoint();
  const caminhoURL = usePathname();
  const searchParams = useSearchParams();

  const searchParamsString = searchParams.toString();
  const theme = useTheme();
  const router = useRouter();

  return (
    <Header
      {...props}
      $style={
        breakpoint === 'mobile'
          ? {
              paddingRight: theme.spacing[4],
              paddingLeft: theme.spacing[4],
            }
          : {}
      }
    >
      <S.Container>
        <S.Conteudo $breakpoint={breakpoint} $caminhoURL={caminhoURL}>
          <Button
            $size={1}
            $variant="ghost"
            $color="neutral"
            $highContrast={true}
            $loading={false}
            $text="Voltar"
            $focusRing={false}
            $IconStart={IconeSeta}
            $iconStartProps={{
              size: theme.typography.font.size[5],
              direcao: 'esquerda',
            }}
            $onClick={() => {
              if (
                !searchParamsString.includes('voltar-home') &&
                [
                  '/cadastrar',
                  '/esqueci-minha-senha',
                  '/redefinir-senha',
                ].includes(caminhoURL)
              ) {
                return router.replace(`/logar?${searchParamsString}`);
              }

              if (caminhoURL === '/forma-pagamento') {
                return router.replace('/sacola');
              }

              if (caminhoURL.includes('/sacola') && !searchParamsString) {
                return router.replace('/');
              }

              return router.back();
            }}
          />
          <Image
            src={logo_chippu_place}
            alt="Chippu Place logo"
            height={theme.typography.font.size[7]}
            priority
          />
        </S.Conteudo>
      </S.Container>
    </Header>
  );
}
